import axios, { AxiosResponse } from "axios";

export interface ProductTier {
	productTierId: string;
	productTierName: string;
	productId: string;
}

export interface ProductTierXBillingPlan {
	productTierXBillingPlanId: string;
	billingPlanId: string;
	productTierId: string;
	invoiceDescription: string;
}

export const getProductTiers = (productId: string) => async (): Promise<AxiosResponse<ProductTier[]>> => {
	return await axios.get(`/api/v1/producttiers/byproduct/${productId}`);
};

export const getProductTierBillingPlans =
	(productId: string) => async (): Promise<AxiosResponse<ProductTierXBillingPlan[]>> => {
		return await axios.get(`/api/v1/producttierxbillingplans/byproduct/${productId}`);
	};
